/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import CloseIcon from '@mui/icons-material/Close'
import EditIcon from '@mui/icons-material/Edit'
import { Grid, Button, CircularProgress } from '@mui/material'
import React, { useState, useRef } from 'react'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'

const containerCss = css`
  border-radius: 6px;
  border-style: dashed;
  border-color: #a5caee;
  padding: 20px;
  height: 305px;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
`

export default function Crop({ file, onSave, onRemove, uploading }) {
  const cropperRef = useRef(null)
  const [preview, setPreview] = useState<string | undefined>()
  const [cropper, setCropper] = useState<any>()

  const handleSave = async () => {
    if (typeof cropper !== 'undefined') {
      cropper.getCroppedCanvas().toBlob(async (blob: Blob | null) => {
        if (blob) {
          const fileName = `${new Date().getTime()}${file.file.name}`
          const croppedFile = new File([blob], fileName, { type: file.file.type })
          setPreview(URL.createObjectURL(croppedFile))
          await onSave(croppedFile)
        }
      }, file.type)
    }
  }

  const handleEdit = () => {
    onRemove()
    setPreview(undefined)
  }

  const handleCancel = () => {
    onRemove()
    setPreview(undefined)
    file.remove()
  }

  return (
    <Grid container direction="column" justifyContent="center" alignItems="center" css={containerCss}>
      <Grid
        item
        sx={{
          textAlign: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
        flexGrow={1}
      >
        {uploading ? (
          <CircularProgress />
        ) : preview ? (
          <React.Fragment>
            <a href="#" style={{ position: 'absolute', top: 15, right: 15, color: 'back' }} onClick={handleEdit}>
              <EditIcon fontSize="large" />
            </a>
            <img src={preview} style={{ borderRadius: '50%', width: 180, height: 180 }} alt="logo" />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <a href="#" style={{ position: 'absolute', top: 15, right: 15, color: 'back' }} onClick={handleCancel}>
              <CloseIcon fontSize="large" />
            </a>
            <Cropper
              ref={cropperRef}
              style={{ height: 220, width: 220, margin: 'auto' }}
              minContainerWidth={220}
              minContainerHeight={220}
              src={file.meta.previewUrl}
              viewMode={1}
              guides={false}
              cropBoxResizable={false}
              aspectRatio={1}
              responsive
              dragMode="move"
              cropBoxMovable={false}
              movable
              center={false}
              background={false}
              checkOrientation
              onInitialized={(instance) => {
                setCropper(instance)
              }}
            />
            <Button
              variant="contained"
              sx={{ fontSize: 14, height: 32, width: 110, marginTop: 'auto' }}
              onClick={handleSave}
            >
              Save
            </Button>
          </React.Fragment>
        )}
      </Grid>
    </Grid>
  )
}
